import React from 'react';

export default function ExitIcon(props: {
  className?: string;
  strokeColor?: string;
  onClick?: (e: React.MouseEvent) => void;
}) {
  return (
    <svg
      className={props.className}
      onClick={props.onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M17 9L13 13.3333M17 9L13 5M17 9L4.33333 9M9.66667 17H1L1 1L9.66667 1"
        stroke={props?.strokeColor || '#343A40'}
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
